import React, { useEffect } from "react";
import AboutMe from "../../components/AboutMe/AboutMe";
import Analysis from "../../components/Analysis/Analysis";
import ClientReview from "../../components/ClientReview/ClientReview";
import Courses from "../../components/Courses/Courses";
import Footer from "../../components/Footer/Footer";
import RecentPost from "../../components/RecentPost/RecentPost";
import Service from "../../components/Service/Service";
import Summary from "../../components/Summary/Summary";
import TopBanner from "../../components/TopBanner/TopBanner";
import Video from "../../components/Video/Video";
import Welcome from "../../components/Welcome/Welcome";
import MainNav from "../../shared/MainNav/MainNav";

import "./Home.css";
export default function Home() {
  useEffect(() => {
    window.scroll(0, 0);
  }, []);
  return (
    <div>
      <MainNav title="E-Learning" />
      <TopBanner />
      <Welcome />
      <Service />
      <Analysis />
      <Summary />
      <RecentPost />
      <Courses />
      <Video />
      <ClientReview />
      <AboutMe />
      <Footer />
    </div>
  );
}
